/*
 * Renneway arama — sonuclar backend API'den gelir (global marka siralamasi):
 *   Grup 1: SAF urunler (%100 sorgu elyafi) — TUM sonuc kumesinde en uste
 *   Grup 2a: sorgu elyafi + POLYESTER karisimlari (elyaf yuzdesi yuksekten dusuge)
 *   Grup 2b: diger karisimlar (yuzde sirali)
 *   Grup 3: kalan eslesmeler
 * Siralama ve SAYFALAMA server-side (/api/public/search); sayfa gecisleri klasik
 * ?page=N linkleridir. Basliklar/gorseller locale'e uygun olarak Shopify
 * /products/{handle}.js uzerinden alinir (TR sayfada TR baslik).
 * API erisilemezse Shopify'in kendi sonuclari aynen kalir (guvenli geri cekilme).
 */
(function () {
  'use strict';

  var API_BASE = (window.RENNEWAY_API_BASE || '').replace(/\/+$/, '');
  var PER_PAGE = 12;

  function getParam(name) {
    try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; }
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildCard(p) {
    var url = root() + 'products/' + encodeURIComponent(p.handle);
    var img = p.image ? (p.image.indexOf('?') > -1 ? p.image + '&width=600' : p.image + '?width=600') : '';
    var ratio = p.ratio ? (100 / p.ratio) : 150;
    return '' +
      '<div class="product--card">' +
        '<div class="product--card-inner product-background-enabled product-border-enabled">' +
          '<div class="product--card-image width-100 pos-relative">' +
            '<a href="' + url + '" class="product--image d-block width-100" aria-label="' + escapeHtml(p.title) + '">' +
              '<div class="media" style="--image_ratio:' + ratio + '%">' +
                (img ? '<img class="product--card-image" src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
              '</div>' +
            '</a>' +
            '<div class="product--card-badges" data-renneway-campaign-slot data-product-handle="' + escapeHtml(p.handle) + '"></div>' +
          '</div>' +
          '<div class="product--card-detail"><div class="product--card-detail-inner"><div class="product--card-detail-content">' +
            '<div class="product--vendor text-small">Renneway</div>' +
            '<a href="' + url + '" class="product--title text-small">' + escapeHtml(p.title) + '</a>' +
          '</div></div></div>' +
        '</div>' +
      '</div>';
  }

  function buildPagination(q, page, totalPages) {
    if (totalPages <= 1) return '';
    function pageUrl(p) {
      var params = new URLSearchParams(window.location.search);
      params.set('q', q);
      if (p > 1) params.set('page', String(p)); else params.delete('page');
      return window.location.pathname + '?' + params.toString();
    }
    var prevLabel = document.documentElement.lang === 'tr' ? 'Öncesi' : 'Prev';
    var nextLabel = document.documentElement.lang === 'tr' ? 'Sonrası' : 'Next';
    var html = '';
    html += page <= 1
      ? '<li class="pagination-item disabled"><p class="pagination-icon"><strong>' + prevLabel + '</strong></p></li>'
      : '<li class="pagination-item"><a class="pagination-icon" href="' + pageUrl(page - 1) + '"><strong>' + prevLabel + '</strong></a></li>';
    for (var p = 1; p <= totalPages; p++) {
      if (totalPages > 7 && p > 2 && p < totalPages - 1 && Math.abs(p - page) > 1) {
        if (html.slice(-11) !== '</li><!--e-->') {
          html += '<li class="pagination-item disabled"><p class="pagination-text">…</p></li><!--e-->';
          // ardisik uc nokta eklememek icin isaret
        }
        continue;
      }
      html += p === page
        ? '<li class="pagination-item active"><p class="pagination-text">' + p + '</p></li>'
        : '<li class="pagination-item"><a class="pagination-text" href="' + pageUrl(p) + '">' + p + '</a></li>';
    }
    html += page >= totalPages
      ? '<li class="pagination-item disabled"><p class="pagination-icon"><strong>' + nextLabel + '</strong></p></li>'
      : '<li class="pagination-item"><a class="pagination-icon" href="' + pageUrl(page + 1) + '"><strong>' + nextLabel + '</strong></a></li>';
    return html;
  }

  function updateResultCount(total) {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.textContent.trim();
      var m = t.match(/^(\d+)\s+(sonuç|sonuc|results?)$/i);
      if (m) { node.textContent = node.textContent.replace(m[1], String(total)); return; }
    }
  }

  function run() {
    if (!API_BASE) return;
    var q = (getParam('q') || '').trim();
    if (!q) return;
    var list = document.querySelector('.main-collection--products-list');
    if (!list) return;
    var page = Math.max(1, parseInt(getParam('page') || '1', 10));

    fetch(API_BASE + '/api/public/search?q=' + encodeURIComponent(q) + '&page=' + page + '&per=' + PER_PAGE)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.ok || !data.total) return; // API yok/hata/0 sonuc → Shopify default kalsin
        // Her sonucun locale'li baslik + gorselini Shopify'dan al
        return Promise.all(data.results.map(function (r) {
          return fetch(root() + 'products/' + encodeURIComponent(r.handle) + '.js')
            .then(function (resp) { return resp.ok ? resp.json() : null; })
            .then(function (pj) {
              // Shopify'da artik olmayan (bayat DB kaydi) urun karti render edilmez — 404 link olusmasin
              if (!pj) return null;
              var img = pj.featured_image || (pj.images && pj.images[0]) || '';
              return {
                handle: r.handle,
                title: pj.title || r.title,
                image: typeof img === 'string' ? img : (img.src || ''),
                ratio: 0.667
              };
            })
            .catch(function () { return { handle: r.handle, title: r.title, image: '', ratio: 0.667 }; });
        })).then(function (cards) {
          cards = cards.filter(Boolean);
          if (!cards.length) return;
          list.innerHTML = cards.map(buildCard).join('');
          // Sayfalama: temanin pagination kabini yeniden kullanilir
          var pag = document.querySelector('ul.pagination, .pagination');
          var pagHtml = buildPagination(q, data.page, data.totalPages);
          if (pag) {
            if (pagHtml) {
              pag.innerHTML = pagHtml;
              var wrap = pag.closest('nav') || pag;
              wrap.style.display = '';
            } else {
              (pag.closest('nav') || pag).style.display = 'none';
            }
          }
          updateResultCount(data.total);
        });
      })
      .catch(function () { /* API erisilemedi — Shopify sonuclari aynen kalir */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
